import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { RhfMuiTextArea } from '../../molecules/fields/rhf-mui-fields';

export const FormEditOcrData = ({ ocrMessage }: { ocrMessage: string }) => {
  const { setValue } = useFormContext();

  useEffect(() => {
    if (ocrMessage) {
      setValue('ocrData', ocrMessage);
    } else {
      setValue('ocrData', '');
    }
  }, [ocrMessage, setValue]);

  return (
    <div className='pt-12'>
      <RhfMuiTextArea name='ocrData' placeholder='OCR Data' rows={20} required parseError={(error) => error.message.toString()} />
    </div>
  );
};
